import { render, staticRenderFns } from "./PaymentSuppliers.vue?vue&type=template&id=108b26d6&"
import script from "./PaymentSuppliers.vue?vue&type=script&lang=js&"
export * from "./PaymentSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports